import { useSystem } from "../api/queries";
import type { GpuStatus } from "../api/types";

function tempColor(t: number): string {
  return t >= 80 ? "var(--bad)" : t >= 65 ? "var(--warn)" : "var(--good)";
}

function Cell({ g }: { g: GpuStatus }) {
  return (
    <div className="gpu-cell" title={`GPU ${g.index} · ${g.name} · ${g.util_pct}% · ${g.temp_c}°C`}>
      <div className="gpu-cell-bar">
        <div className="gpu-cell-fill" style={{ height: `${Math.max(3, g.util_pct)}%` }} />
      </div>
      <span className="gpu-cell-id mono">{g.index}</span>
      <span className="gpu-cell-t mono" style={{ color: tempColor(g.temp_c) }}>{g.temp_c}°</span>
    </div>
  );
}

// Thin always-on GPU fleet strip for the dashboard header.
export function FleetStrip() {
  const { data } = useSystem();
  const gpus = data?.gpus ?? [];
  const busy = gpus.filter((g) => g.util_pct > 5).length;
  return (
    <div className="fleet-strip">
      <span className="fleet-label dim mono">FLEET {busy}/{gpus.length}</span>
      <div className="fleet-cells">
        {gpus.map((g) => <Cell key={g.index} g={g} />)}
      </div>
    </div>
  );
}
